import React from 'react';
import Loadable from 'react-loadable';
// eslint-disable-next-line no-unused-vars
// import Login from 'components/Login';

const LoadableComponent = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'webviewloginhook' */ './WebViewLoginHook'),
  loading: () => null,
});

export default class WithWebViewLoginHook extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    if (
      this.props.frmapp &&
      typeof window !== 'undefined' &&
      window.location.href.indexOf('hv=yes') !== -1
    ) {
      return (
        <div className="webviewloginhook">
          <LoadableComponent {...this.props} />
        </div>
      );
    }
    return null;
  }
}
